<template>
  <div class="PuriContents7">
    <div class="horizontal sheets">
      <div class="left-sheets">
        <div class="left-sheet" :class="[
          {'square --left': (arcadeName === 'Bépiu.' || arcadeName === 'i my merry') &&!surpriseShot2s[0]},
          sampleImage[0]
      ]">
          <img :src="uris[0]">
          <div v-if="hasgraffs[0] && !surpriseShot2s[0]" class="graffity --leftSheet" />
          <div v-if="surpriseShots[0] || surpriseShot2s[0]" class="surprise --leftSheet" />
        </div>
      </div>
      <div class="right-sheets">
        <div class="horizontal">
          <div class="right-sheet" :class="[
            {'square --rightTop': (arcadeName === 'Bépiu.' || arcadeName === 'i my merry') &&!surpriseShot2s[1]},
            sampleImage[1]
          ]">
            <img :src="uris[1]">
            <div v-if="hasgraffs[1] && !surpriseShot2s[1]" class="graffity" />
            <div v-if="surpriseShots[1] || surpriseShot2s[1]" class="surprise" />
          </div>
          <div class="right-sheet" :class="[
            {'square --rightTop': (arcadeName === 'Bépiu.' || arcadeName === 'i my merry') &&!surpriseShot2s[2]},
            sampleImage[2]
          ]">
            <img :src="uris[2]">
            <div v-if="hasgraffs[2] && !surpriseShot2s[2]" class="graffity" />
            <div v-if="surpriseShots[2] || surpriseShot2s[2]" class="surprise" />
          </div>
          <div class="right-sheet" :class="[
            {'square --rightTop': (arcadeName === 'Bépiu.' || arcadeName === 'i my merry') &&!surpriseShot2s[3]},
            sampleImage[3]
          ]">
            <img :src="uris[3]">
            <div v-if="hasgraffs[3] && !surpriseShot2s[3]" class="graffity" />
            <div v-if="surpriseShots[3] || surpriseShot2s[3]" class="surprise" />
          </div>
        </div>
        <div class="horizontal">
          <div class="right-sheet --rightBottom" :class="[
            {'square': (arcadeName === 'Bépiu.' || arcadeName === 'i my merry') &&!surpriseShot2s[4]},
            sampleImage[4]
          ]">
            <img :src="uris[4]">
            <div v-if="hasgraffs[4] && !surpriseShot2s[4]" class="graffity" />
            <div v-if="surpriseShots[4] || surpriseShot2s[4]" class="surprise" />
          </div>
          <div class="right-sheet --rightBottom" :class="[
            {'square': (arcadeName === 'Bépiu.' || arcadeName === 'i my merry') &&!surpriseShot2s[5]},
            sampleImage[5]
          ]">
            <img :src="uris[5]">
            <div v-if="hasgraffs[5] && !surpriseShot2s[5]" class="graffity" />
            <div v-if="surpriseShots[5] || surpriseShot2s[5]" class="surprise" />
          </div>
          <div class="right-sheet --rightBottom" :class="[
            {'square': (arcadeName === 'Bépiu.' || arcadeName === 'i my merry') &&!surpriseShot2s[6]},
            sampleImage[6]
          ]">
            <img :src="uris[6]">
            <div v-if="hasgraffs[6] && !surpriseShot2s[6]" class="graffity" />
            <div v-if="surpriseShots[6] || surpriseShot2s[6]" class="surprise" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PuriContents7",
  props: {
    uris: {
      type: Array,
      require: true
    },
    selects: {
      type: Array,
      require: true
    },
    arcadeName: {
      type: String,
      require: ''
    },
    hasgraffs: {
      type: Array,
      require: true
    },
    surpriseShots: {
      type: Array,
      require: true
    },
    surpriseShot2s: {
      type: Array,
      require: true
    }
  },
  computed: {
    sampleImage() {
      return this.selects.map(selected => selected ? '' : 'sampleImage')
    }
  }
}
</script>

<style lang="scss" scoped>
.horizontal {
  display: flex;
}
.sheets {
  margin: 0px -2px;
}

.right-sheet,
.left-sheet {
  position: relative;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .graffity,
  .surprise {
    position: absolute;
    width: 18px;
    height: 18px;
    right: 1px;
    background-size: contain;
    z-index: 10;
  }
  .graffity {
    bottom: 1px;
    background-image: url(../assets/Png/Album/Album_Puri_Graffiti.png);
  }
  .surprise {
    top: 1px;
    background-image: url(../assets/Png/Album/Album_PuriMotto.png);
  }
  .--leftSheet {
    width: 35px;
    height: 35px;
  }
}
.left-sheets {
  width: calc(40% - 4px);
}
.left-sheet {
  margin-right: 4px;
  height: 147px;
  overflow: hidden;
}
.right-sheets {
  width: 60%;
}
.right-sheet {
  margin: 0 4px 4px 0;
  width: 33.3333%;
  height: 71.5px;
  overflow: hidden;
  text-align: center;
  &:last-child {
    padding-right: 0;
    margin-right: 0;
  }
}

.sampleImage {
  position: relative;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    opacity: 1;
    filter: saturate(180%);
    background-image: url(../assets/Png/Common/puriSample.png);
    background-repeat: no-repeat;
    background-size: cover;
  }
}
</style>
